import 'core-js'
import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from './vuetify'
import VueTippy from 'vue-tippy'
import VueWait from 'vue-wait'
import VeeValidate from 'vee-validate'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'

import './service/'

import './helper/i18n'
import { organizationSlug, user } from './constants'

/**
 * Gloval vue modules
 */
import store from './store'
import organizationRoutes from './routes/organization'
import accountRoutes from './routes/account'
import routerGuards from './guards/routerGuards'
import './auth/'

/**
 * Vue components
 */
import Containers from '~containers'
import Components from '~components'
import Icon from '~components/Icon/Icon'
import AppContainer from './AppContainer'
import Layout from './pages/Layout.vue'

import apolloClient from './apollo/client-configs/default'
import VueApollo from 'vue-apollo'

Vue.component('Layout', Layout)
Vue.use(VueApollo)
Vue.use(VueRouter)
Vue.use(VueTippy, {
  placement: 'top',
  arrow: false,
  interactive: true,
  animateFill: false,
})
Vue.use(VueWait)
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
})

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdiSvg',
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})
/**
 * Global Vue Components
 */
Vue.component('Icon', Icon)

const tenantRouter = new VueRouter({
  linkActiveClass: 'active',
  linkExactActiveClass: 'active active-exact',
  base: `/${organizationSlug}`,
  mode: 'history',
  routes: organizationRoutes,
})

const userRouter = new VueRouter({
  linkActiveClass: 'active',
  linkExactActiveClass: 'active active-exact',
  base: '/settings',
  mode: 'history',
  routes: accountRoutes,
})

routerGuards(tenantRouter)

const wait = new VueWait({ useVuex: true })

const VueConfig = {
  el: '.app',
  store,
  wait,
  apolloProvider,
  vuetify,
  components: {
    AppContainer,
    ...Containers,
    ...Components,
  },
}

if (organizationSlug) {
  VueConfig.router = tenantRouter
} else if (user) {
  VueConfig.router = userRouter
}

const app = new Vue(VueConfig)

export default app
